module.exports = __webpack_public_path__ + "static/media/rendimiento esperado-verde_old.692f0263.svg";